(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc2-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sc2SubInit) return;
    window.__sc2SubInit = true;

    var touch = window.matchMedia('(hover: none)');

    function closeDropdowns() {
      document.querySelectorAll('.sc2-dd.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    }

    /* capture phase, so the drawer's own click handlers don't swallow the tap */
    document.addEventListener('click', function (e) {
      /* menu panel: tapping the item (Decor) or the + button opens / closes its sub-links */
      var tog = e.target.closest('[data-sc2-subtog]');
      var row = e.target.closest('.sc2-sheet li.has-sub > a');
      var trigger = tog || row;
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var li = trigger.closest('li.has-sub');
        var open = li.classList.toggle('is-sub-open');
        var btn = li.querySelector(':scope > [data-sc2-subtog]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      /* top bar on touch screens: first tap opens the dropdown, second tap follows the link */
      var link = e.target.closest('.sc2-dd > a');
      if (link && touch.matches) {
        var dd = link.parentNode;
        if (!dd.classList.contains('is-open')) {
          e.preventDefault();
          closeDropdowns();
          dd.classList.add('is-open');
          return;
        }
      }

      if (!e.target.closest('.sc2-dd')) closeDropdowns();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdowns();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
